module.exports = __webpack_public_path__ + "static/media/Global-Biotechnology-Congress.8a81b6fc.jpg";